import React from "react";
import { useLang } from "../LanguageContext";

const NPM_DEPS = [
  { name: "React",              version: "18",   license: "MIT", url: "https://github.com/facebook/react" },
  { name: "React Router",       version: "6",    license: "MIT", url: "https://github.com/remix-run/react-router" },
  { name: "React Scripts (CRA)",version: "5",    license: "MIT", url: "https://github.com/facebook/create-react-app" },
  { name: "Chart.js",           version: "4",    license: "MIT", url: "https://github.com/chartjs/Chart.js" },
  { name: "react-chartjs-2",    version: "5",    license: "MIT", url: "https://github.com/reactchartjs/react-chartjs-2" },
  { name: "TanStack Table",     version: "8",    license: "MIT", url: "https://github.com/TanStack/table" },
  { name: "react-icons",        version: "4",    license: "MIT", url: "https://github.com/react-icons/react-icons" },
  { name: "qr-code-styling",    version: "1",    license: "MIT", url: "https://github.com/kozakdenys/qr-code-styling" },
  { name: "react-bootstrap",    version: "2",    license: "MIT", url: "https://github.com/react-bootstrap/react-bootstrap" },
];

const OWN_PROJECTS = [
  {
    name: "myRemoteTimer",
    desc: "Shared countdown timer for remote teams.",
    url: "https://github.com/its-really-me/my-remote-timer",
    license: "MIT",
  },
  {
    name: "FastVote",
    desc: "Instant anonymous polling for meetings and workshops.",
    url: "https://github.com/its-really-me/fastvote",
    license: "MIT",
  },
  {
    name: "QR-Code-Generator",
    desc: "Client-side QR code generator with style options.",
    url: "https://github.com/its-really-me/qr-code-generator",
    license: "MIT",
  },
  {
    name: "Camper Monitor",
    desc: "Real-time camper van 12V battery dashboard.",
    url: "https://github.com/its-really-me/camper-monitor",
    license: "MIT",
  },
];

function Licenses() {
  const { t } = useLang();

  return (
    <div className="imprint">
      <div className="page-section-header">
        <span className="section-label">{t("imprint.label")}</span>
        <div className="subhead">{t("licenses.title")}</div>
      </div>

      <div className="imp-infos">
        <p className="sub2head">{t("licenses.ownProjectsTitle")}</p>
        <p className="text" style={{marginBottom: "1rem"}}>{t("licenses.ownProjectsDesc")}</p>
        <table className="showcase-table">
          <thead>
            <tr>
              <th>{t("licenses.colProject")}</th>
              <th>{t("licenses.colDescription")}</th>
              <th>{t("licenses.colLicense")}</th>
            </tr>
          </thead>
          <tbody>
            {OWN_PROJECTS.map(({ name, desc, url, license }) => (
              <tr key={name}>
                <td><a className="link" href={url} target="_blank" rel="noreferrer">{name}</a></td>
                <td>{desc}</td>
                <td>{license}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="imp-legal">
        <p className="sub2head">{t("licenses.npmTitle")}</p>
        <p className="text" style={{marginBottom: "1rem"}}>{t("licenses.npmDesc")}</p>
        <table className="showcase-table">
          <thead>
            <tr>
              <th>{t("licenses.colPackage")}</th>
              <th>{t("licenses.colVersion")}</th>
              <th>{t("licenses.colLicense")}</th>
            </tr>
          </thead>
          <tbody>
            {NPM_DEPS.map(({ name, version, license, url }) => (
              <tr key={name}>
                <td><a className="link" href={url} target="_blank" rel="noreferrer">{name}</a></td>
                <td>{version}.x</td>
                <td>{license}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Licenses;
